<template>
  <div class="subtitle">
    <div>
      {{ $t("walletVerification.subtitle_11_1") }}
      {{ accountAddress }}
      {{ $t("walletVerification.subtitle_11_2") }}
    </div>

    <div
      v-if="!satusSign"
      class="mt-4"
    >
      {{ $t("walletVerification.subtitle_12") }}
    </div>
    <div
      v-else
      class="mt-4"
    >
      {{ $t("walletVerification.subtitle_13") }}
    </div>

    <div v-if="satusSign">
      {{ $t("walletVerification.subtitleNote") }}
    </div>

    <AuButton
      :disabled="satusSign"
      class="mt-2"
      type="primary"
      center
      width="230px"
      @click="$emit('startVerify')"
    >
      <div class="btn_metamask">
        {{ $t("walletVerification.btn_4") }}
      </div>
    </AuButton>
  </div>
</template>

<script>
import AuButton from "@/components/extended/AuButton.vue";

export default {
  name: "WalletVerify",
  components: { AuButton },
  props: {
    accountAddress: {
      type: String,
      default: ""
    },
    satusSign: Boolean
  }
};
</script>
